import moment from "moment";
import { createData, getData } from "../../util/API";

// Card colour for a partner on the "Partner KYC status" list.
export function attempterCardClass(status) {
  if (status === "verified") return "kyc-notice-card kyc-notice-card--done";
  if (status === "rejected") return "kyc-notice-card kyc-notice-card--rejected";
  return "kyc-notice-card kyc-notice-card--pending";
}

export function rejectedByLine(rejection) {
  const who = (rejection && rejection.rejected_by_name) || "Accounts";
  const at = rejection && rejection.rejected_at;
  return `Marked incorrect by ${who}${at ? ` · ${moment(at).format("D MMM, h:mm A")}` : ""}`;
}

// Any internal user may send a partner's corrected KYC back; the API refuses partner logins.
export async function resubmitKyc(partnerId) {
  const fallback = "Could not send to accounts";
  try {
    const res = await createData(`/finance/kyc-notifications/${partnerId}/resubmit/`, {});
    if (res && res.data && res.data.status === 200) return { ok: true, message: res.data.message };
    return { ok: false, message: (res && res.data && res.data.message) || fallback };
  } catch (error) {
    const data = error && error.response && error.response.data;
    return { ok: false, message: (data && data.message) || fallback };
  }
}

// Rejected KYC for a page of partner cards, in one call.
export async function fetchKycRejections(partnerIds) {
  const ids = Array.from(new Set((partnerIds || []).filter(Boolean).map(String)));
  if (!ids.length) return {};
  try {
    const res = await getData(`/finance/kyc-rejections/?partner_ids=${ids.join(",")}`);
    return (res && res.data && res.data.rejections) || {};
  } catch (e) {
    return {};
  }
}
